module.exports = __webpack_public_path__ + "img/hj_2.cd55fad7.jpg";